// The dataset packs a row's sources into one cell, " ; "-separated.
const SOURCE_SEPARATOR = ';';

/**
 * The sources a row carries, named by where they come from.
 *
 * The host is what tells two sources apart at a glance; the full URL is far too
 * long for a card or a log row, and a bare "Source 1, Source 2" says nothing.
 */
export const parseSources = (sources) =>
    (sources || '')
        .split(SOURCE_SEPARATOR)
        .map((url) => url.trim())
        .filter(Boolean)
        .map((url) => {
            let label = url;

            try {
                label = new URL(url).hostname || url;
            } catch {
                // Not a URL we can parse — show it as written rather than
                // dropping a source the data does carry.
            }

            return { url, label };
        });
